/**
 * @license
 * Copyright© Celligence International, LLC - 2023
 * This software program is protected by copyright laws and is the property of
 * Celligence International, LLC (Celligence). Any unauthorized reproduction,
 * distribution, modification, or public display of this program, without the
 * explicit permission of Celligence is strictly prohibited. If you have gained
 * access to this program without the expressed approval of Celligence report
 * the incident to legal@celligence.com.
*/
import { useEffect, Suspense, lazy, useState } from "react";
import Header from "./components/Header";
//import CallMeForm from './components/CallMeForm';
import Body from "./components/Body";
import Footer from "./components/Footer";
import "@fontsource/poppins";
import Navbar from "./components/Navbar";
import Contact from "./components/SignUpForm";
import "./App.css";
import CacheBuster from "react-cache-buster";
import appversion from "../package.json";
import jsonData from "./components/ai-branding.json"; // Import the JSON file
import axios from "axios";
import { CookieSetting } from "cookiesetting-component";

const LogoSection = lazy(() => import("./components/Logo Section/Logo"));

function App() {
  const [links, setLinks] = useState(null); // Set initial state as null
  const appVersion = appversion.version;

  useEffect(() => {
    const script = document.createElement("script");

    script.type = "text/javascript";
    script.src = process.env.REACT_APP_SWMC_ANALYTICS;
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  useEffect(() => {
    const fetchLinks = async () => {
      try {
        const response = await axios.get(process.env.REACT_APP_ANGELAI_JSON);
        setLinks(response.data);
      } catch (error) {
        console.error("Error fetching links:", error);
        setLinks(jsonData); // Use local JSON data if fetching fails
      }
    };

    if (!links) {
      fetchLinks(); // Fetch JSON only if the links data is not available
    }
  }, [links]);

  useEffect(() => {
    if (!links) {
      setLinks(jsonData); // Set local JSON data as fallback initially
    }
  }, []);
  return (
    <>
      <CacheBuster
        currentVersion={appVersion}
        isEnabled={true}
        isVerboseMode={false} //If true, the library writes verbose logs to console.
        metaFileDirectory={"."}
      >
        {links ? (
          <>
            <Navbar />
            <Header />
            <Contact />

            <Suspense fallback={<div />}>
              <LogoSection />
            </Suspense>

            <Body links={links.current} />
            <Footer />
          </>
        ) : (
          <div>Loading...</div>
        )}
        <CookieSetting
          privacyPolicyLink={process.env.REACT_APP_PRIVACY_POLICY_LINK}
          configUrl={process.env.REACT_APP_COOKIE_SETTING_JSON}
          analytics={process.env.REACT_APP_ANALYTICS_PATH}
        />
      </CacheBuster>
    </>
  );
}

export default App;
